import type { Documento } from '@/services/Documentos';

const numero = (valor: string | null | undefined): number => parseFloat(valor ?? '0') || 0;

/**
 * IBS total da nota (SPEC-007, §3, item 1): o que o servidor manda em `IBSTotal` (o `vIBS` gravado
 * da nota, ou a soma das parcelas); se não vier, IBS UF + IBS Município.
 */
export function ibsTotalDaNota(doc: Pick<Documento, 'IBSTotal' | 'vIBSUF' | 'vIBSMun'>): number {
  if (doc.IBSTotal != null && doc.IBSTotal.trim() !== '') {
    return numero(doc.IBSTotal);
  }

  return numero(doc.vIBSUF) + numero(doc.vIBSMun);
}

/** Tipo da nota (SPEC-007, §3, item 2): "Entrada" ou "Saída", do `tpNF`; "-" no modelo que não o tem. */
export function tipoDaNota(doc: Pick<Documento, 'Tipo'>): string {
  return doc.Tipo?.trim() || '-';
}

/** Tipo e finalidade da nota na mesma coluna (SPEC-018, §3, item 4): "Saída · Devolução"; "-" sem nenhum dos dois. */
export function tipoEFinalidadeDaNota(doc: Pick<Documento, 'Tipo' | 'Finalidade'>): string {
  const partes = [doc.Tipo?.trim(), doc.Finalidade?.trim()].filter(Boolean);
  return partes.length > 0 ? partes.join(' · ') : '-';
}
